// İSG uzmanı portalı — Şube detay: Saha (Site) yönetimi (api-contract §9.6). Saha,
// şube modülünün alt yönetimidir (aynı `admin-branches` hakkı). Şube adı navigasyon
// state'inden gelir (tekil GET şube ucu sözleşmede yok); deep-link'te genel başlık.

import { Breadcrumb, PageHeader, type SiteAdminDto, adminApi } from '@isgportal/shared';
import { MapPin } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import { EntityCrudTable } from '../../components/admin/EntityCrudTable';
import { adminKeys } from '../../lib/adminKeys';

interface BranchNavState {
  branchName?: string;
  companyName?: string;
}

export function BranchDetailPage() {
  const { t } = useTranslation();
  const { companyUuid = '', branchUuid = '' } = useParams();
  const location = useLocation();
  const state = (location.state ?? {}) as BranchNavState;
  const branchName = state.branchName ?? t('admin.sites.branchFallback');
  const companyName = state.companyName;

  return (
    <div className="flex flex-col gap-6">
      <Breadcrumb
        items={[
          { label: t('admin.nav'), href: '/admin' },
          { label: t('admin.tab.companies'), href: '/admin/companies' },
          ...(companyName ? [{ label: companyName, href: `/admin/companies/${companyUuid}` }] : []),
          { label: branchName },
        ]}
      />
      <PageHeader title={branchName} id={t('admin.sites.title')} />

      {/* `EntityCrudTable` kendi Tile'ını taşır — `CompanyDetailPage.tsx`'in AYNI notu. */}
      <EntityCrudTable<SiteAdminDto>
        queryKeyBase={adminKeys.sites(companyUuid, branchUuid)}
        queryFn={(params) => adminApi.listSites(companyUuid, branchUuid, params)}
        createSubmit={(values) => adminApi.createSite(companyUuid, branchUuid, values)}
        updateSubmit={(site, values) =>
          adminApi.updateSite(companyUuid, branchUuid, site.uuid, values)
        }
        labels={{
          icon: MapPin,
          caption: t('admin.sites.title'),
          colName: t('admin.sites.col.name'),
          colCode: t('admin.sites.col.code'),
          newLabel: t('admin.sites.new'),
          createTitle: t('admin.sites.create.title'),
          editTitle: t('admin.sites.edit.title'),
          fieldName: t('admin.sites.field.name'),
          fieldCode: t('admin.sites.field.code'),
          searchPlaceholder: t('admin.sites.searchPlaceholder'),
          createdMessage: t('admin.sites.created'),
          updatedMessage: t('admin.sites.updated'),
          count: (count) => t('admin.sites.count', { count }),
        }}
      />
    </div>
  );
}
